import React, { useMemo } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import PageBreadcrumb from "../../common/PageBreadcrumb/PageBreadcrumb";
import { parseCapaContextFromSearchParams } from "./capaConstants";
import CapaCreateForm from "./CapaCreateForm";
import { useCapaAccess } from "./capaAccess";

const CapaCreate = () => {
  const { userData, canAddCapa } = useCapaAccess();
  const [searchParams] = useSearchParams();

  const ctx = useMemo(
    () => parseCapaContextFromSearchParams(searchParams),
    [searchParams],
  );

  if (!userData) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: 200 }}
      >
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (!canAddCapa) {
    return <Navigate to="/notification-center" replace />;
  }

  return (
    <div>
      <PageBreadcrumb
        items={[
          { label: "Home", path: "/notification-center" },
          { label: "CAPA", path: "/capa" },
          { label: "Create" },
        ]}
      />
      <CapaCreateForm context={ctx} variant="page" />
    </div>
  );
};

export default CapaCreate;
